<template>
  <div class="news">
    <table  class="table table-bordered table-hover">
        <tr >
          <th style="width:4%;">
            <input type="checkbox" id="checkbox" v-model="checked" @change="changeAllChecked()" />
          </th>
          <th style="width:82%">标题内容</th>
          <th style="width:15%">时间</th>
        </tr>

        <tr v-for="(item,index) in arrs" :key="index"  style="width:100%">

          <td style="width:4%;text-align:center">
            <!-- value的值就是v-model的值 -->
            <input type="checkbox" :value="item" v-model="checkedData" />
          </td>
          <td> <router-link :to="'/detail/' + item.id" class="title" >{{item.title}}</router-link></td>
          <td style="width:15%;text-align: center;color:#999">{{item.updateTime}}</td>
        </tr>
        <tr ><td colspan="3" class="border-borttom"><button class="btn active">全部标记已读</button><button class="btn">全部取消</button></td></tr>
      </table>
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  props: {
    arrs: Array
  },
  data: function () {
    return {
      currentPage: 1, // 当前页号
      activenum: 0, // 每页大小
      pagesize: 5,
      checked: false,
      checkedData: []
    }
  },
  computed: {
    page_arrs () {
      let {currentPage, pagesize} = this
      return this.arrs.slice((currentPage - 1) * pagesize, currentPage * pagesize)
    },
    current_page () {
      return this.currentPage
    }
  },
  methods: {
    primaryPage () {
      this.currentPage = 1
      this.activenum = 0
    },
    prePage () {
      if (this.currentPage === 1) {
        this.activenum = 1
        return
      }
      this.currentPage = this.currentPage - 1
      this.activenum = 1
    },
    nextPage () {
      if (this.currentPage === Math.ceil(this.arrs.length / this.pagesize)) {
        return
      }
      this.currentPage = this.currentPage + 1
      this.activenum = 2
    },
    lastPage () {
      this.currentPage = Math.ceil(this.arrs.length / this.pagesize)
      this.activenum = 3
    },
    changeAllChecked(){

    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .news{
    background:#fff;
    padding: 28px;
    padding-bottom:10px;
  }
  .newslist{
    background:#fbfbfb;
    padding:20px;
    margin-bottom:20px;
    height:120px;
    &:hover{
      box-shadow: 0px 0px 10px #999;
    }
    .title{
      font-size:16px;
      line-height:24px;
      height:48px;
      ellipsis2();
      margin-bottom:10px;
    }
    .author{
      font-size:14px;
      color:#999;
    }
    .col-md-9{
       border-right:1px dashed #efefef;
    }
    .col-md-3{
       text-align:center;
      .date{
        font-size:30px;
        padding-top:10px;
        margin-bottom:20px;
      }
      .year{
        color:#999;
      }
    }
  }
  .btn{
    width:100px;
    height:32px;
    line-height:32px;
    padding:0;
    background:#cbccce;
    text-align:center;
    color:#fff;
    border:none;
    margin-right:15px;
  }
  .active{
    background: $bgColor;
  }
  th{
    background:#f6f6f8;
    text-align:center;
  }
  .table-hover>:hover {
    background-color: #f5f5f5;
  }
  .title{
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/pages/info/components/NewsList.vue